import { useQuery } from '@tanstack/react-query';
import { mumulLiveService } from 'shared/src/api';
import { queryKey } from '../constant/queryKey';

/**
 * 무물라이브 현재 캠페인 조회.
 * LIVE 상태로 노출될 때 campaign_sno 를 얻기 위해 사용한다.
 * `enabled`(LIVE 노출 여부) 가 true 이고 `profileSno` 가 있을 때만 호출한다.
 */
export const useMumulLiveCurrentCampaign = (
  profileSno: number | null,
  enabled = true,
) => {
  return useQuery({
    queryKey: queryKey.mumulLiveCurrentCampaign(profileSno ?? 0),
    queryFn: () =>
      mumulLiveService.getMumulLiveCurrentCampaign(profileSno as number),
    enabled: enabled && profileSno != null,
  });
};
